class BaseManipulateInput {
  constructor(input) {
    this.input = jQuery(input);
  }

  getValue() {}
  setValue() {}
}

window.BaseManipulateInput = BaseManipulateInput;
